/* eslint-disable */
import axios from "../index";

const getAll = () => {
   return axios.get('video')
}



const api = { getAll }

export default api;